export default __webpack_public_path__ + "static/media/PAFI_Pengumuman RUPS LB 2025.c16f7235.pdf";